import axios from '@/axios';
import router from '@/router';
import {dev} from '@/api/url';

// サーバーURL
const baseUrl = dev; // エンドポイント
const headers = {}
headers['Content-type'] = 'application/json'

const config = { //axiosの基本設定を定義
  timeout: 30000,//要請がtimeoutまでの時間,30秒
  method: null, //要請方法を指定
  emulateJSON: true,//JSONではなくURLの形式で送信する
  url: '',//要請されるURLを設定
  headers, //要請に使うヘーダ設定(以前設定したheaders)
  data: null, //データの初期値をnullで設定
  // withCredentials: true,
};

export default {
  // 画面一覧を取得するメソッド
  createNew: (screens, staffName, authUserId, sessionKey) => {
    // エンドポイント設定
    config.url = baseUrl + "/api/screen/add"
    config.method = "post"
    config.data = { screens, staffName, authInfo: {authUserId, sessionKey} };  // POSTリクエストで送るデータ設定

    return axios.request(config)
      .then(res => {
        return res;  // サーバーからの応答データを返す
      })
      .catch(err => {
        let ErrMsg = '';

        // ネットワークエラーの場合
        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message; // ネットワークエラー発生時
        } else if (err.response) {
          // サーバーからエラーレスポンスが返された場合
          if (err.response.status === 401) {
            ErrMsg = err.response.data.message || '認証エラー発生';
            router.push('/login'); // ログインページにリダイレクト
          } else if (err.response.status === 404) {
            ErrMsg = err.response.data.message || '画面が見つかりません';
          } else {
            ErrMsg = err.response.data.message || 'その他のエラーメッセージ';
          }
        } else {
          // その他のエラー
          ErrMsg = err.message || '予期しないエラー';
        }
        return {
            status: err.response?.status || 500,
            message: ErrMsg,
            response: err.response
          };// エラーメッセージを返す
      });
  },
  // 画面一覧を取得するメソッド
  screenEdit: (authUserId, sessionKey, staffName, screenId, screenExplanation) => {
    // エンドポイント設定
    config.url = baseUrl + "/api/screen/editScreenExplanation"
    config.method = "post"
    config.data = {
      authInfo: { authUserId, sessionKey }, staffName, screenId, screenExplanation
    };  // POSTリクエストで送るデータ設定

    return axios.request(config)
      .then(res => {
        return res;  // サーバーからの応答データを返す
      })
      .catch(err => {
        let ErrMsg = '';

        // ネットワークエラーの場合
        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message; // ネットワークエラー発生時
        } else if (err.response) {
          // サーバーからエラーレスポンスが返された場合
          if (err.response.status === 401) {
            ErrMsg = err.response.data.message || '認証エラー発生';
            router.push('/login'); // ログインページにリダイレクト
          } else if (err.response.status === 404) {
            ErrMsg = err.response.data.message || '画面が見つかりません';
          } else {
            ErrMsg = err.response.data.message || 'その他のエラーメッセージ';
          }
        } else {
          // その他のエラー
          ErrMsg = err.message || '予期しないエラー';
        }

        return ErrMsg; // エラーメッセージを返す
      });
  }
};
